export const GOALS = {
    prospect: "Win a new client",
    renewal: "Prepare for a renewal",
    handoff: "Hand off to my client",
    learn: "Learn the products",
};

export const GOAL_OPTIONS = [
    { id: "all", label: "All materials", hint: "Browse everything" },
    { id: "prospect", label: GOALS.prospect, hint: "Pitch a business owner or group" },
    { id: "renewal", label: GOALS.renewal, hint: "Show value, add coverage" },
    { id: "handoff", label: GOALS.handoff, hint: "For Plan Administrators & employees" },
    { id: "learn", label: GOALS.learn, hint: "Get up to speed yourself" },
];

export const SECTIONS = [
    { id: "general", label: "General", eyebrowClass: "text-secondary-dark" },
    { id: "bo", label: "Business Owner Health Spending Accounts", eyebrow: "Business Owner HSA", eyebrowClass: "text-primary-darker" },
    { id: "hsa", label: "Health Spending Account", eyebrowClass: "text-primary-darker" },
    { id: "lsa", label: "Lifestyle Spending Account", eyebrowClass: "text-teal-700" },
    { id: "ch", label: "CoreHealth+", eyebrowClass: "text-blue-900" },
    { id: "working", label: "Working With NHC", eyebrowClass: "text-secondary-dark" },
    { id: "pa", label: "Plan Administrator (PA) Documents", eyebrowClass: "text-gray-700" },
    { id: "emp", label: "Employee Documents", eyebrowClass: "text-gray-700" },
];

const doc = (id, section, title, file, thumbnail, goals, description) => ({
    id,
    section,
    title,
    href: `/files/${file}`,
    thumbnail: `/thumbnails/${thumbnail}`,
    goals,
    description,
});

export const DOCUMENTS = [
    doc("why-nhc", "general", "Why Choose NHC", "Why Choose NHC.pdf", "HSAFeatures.png", ["prospect"],
        "Online onboarding, mobile claiming and expert adjudication in one place."),
    doc("why-sa", "general", "Why Add a Spending Account", "Why Add a Spending Account.pdf", "SpendingAccountThumbnail.png", ["prospect", "renewal"],
        "Make the case for adding a spending account to an existing benefits plan."),
    doc("sched", "general", "Scheduled Credits", "Scheduled Credits.pdf", "ScheduledCredits.png", ["prospect", "renewal"],
        "Flexible, timed benefit allocations that grow through the year."),
    doc("who-nhc", "general", "Who is NHC", "Benefit Proposal Generic.pdf", "Benefit Proposal Generic.png", ["prospect", "learn"],
        "An introduction to National HealthClaim for new clients."),
    doc("admin-fee", "general", "What you get for the admin fee", "What you get for the admin fee.pdf", "AdminFee.png", ["prospect", "renewal"],
        "What the admin fee covers, claim by claim, versus traditional premiums."),
    {
        id: "meet-gary",
        section: "bo",
        family: true,
        title: "HSA Tax Savings Stories",
        description: "The “Meet Gary” comparison, now with 14 business owners across trades, retail, health and more.",
        goals: ["prospect", "renewal"],
    },
    doc("bo-detailed", "bo", "Business Owner - HSA Benefit Solution - Detailed", "Business Owner - HSA Benefit Solution - Detailed.pdf", "LongCopy.png", ["prospect", "learn"],
        "Why an owner-only HSA makes sense, with affordability and tax points."),
    doc("hsa-one", "hsa", "HSA One Pager", "HSA One Pager.pdf", "HSAOnePager.png", ["prospect"],
        "A quick overview for employers: set the budget, employees choose."),
    doc("hsa-det", "hsa", "HSA Detailed", "HSA Detailed.pdf", "HSADetailed.png", ["prospect", "learn"],
        "How a Health Spending Account works, step by step, for employer groups."),
    doc("hsa-guide", "hsa", "Complete HSA Eligible Expenses Guide", "Complete HSA Eligible Expenses Guide.pdf", "HSAEligibleExpensesGuide.png", ["handoff", "learn"],
        "What a standard HSA covers and how existing insurance affects claims."),
    doc("hsa-list", "hsa", "HSA Eligible Expenses One Page", "HSA Eligible Expenses One Page.pdf", "HSAEligibleExpensesOnePage.png", ["handoff"],
        "A one-page list of eligible expenses employees can keep handy."),
    doc("hsa-plus", "hsa", "Enhanced Benefits (HSA+)", "Enhanced Benefits HSA.pdf", "EB_HSA.png", ["renewal", "prospect"],
        "Targeted credits for mental wellness, fertility, orthodontics and more."),
    doc("lsa-stand", "lsa", "Lifestyle Spending Account - Stand Alone", "Lifestyle Spending - Stand Alone.pdf", "LifestyleSpendingAccountOnly.png", ["prospect"],
        "A Lifestyle Spending Account offered on its own."),
    doc("lsa-hsa", "lsa", "Lifestyle Spending Account + Health Spending", "Lifestyle Spending - Plus Health Spending.pdf", "LifestyleSpending.png", ["prospect", "renewal"],
        "A Lifestyle Spending Account paired with a Health Spending Account."),
    doc("lsa-rsp", "lsa", "Lifestyle Spending - RSP", "Lifestyle Spending - RSP.pdf", "LifestyleSpending.png", ["prospect"],
        "Lifestyle spending paired with RSP contributions."),
    doc("lsa-cat", "lsa", "LSA Category List", "LSA Category List (View Only).pdf", "LSA Category List View.png", ["handoff"],
        "The categories a Lifestyle Spending Account can cover."),
    doc("lsa-plus", "lsa", "Enhanced Benefits (LSA+)", "Enhanced Benefits LSA.pdf", "EB_LSA.png", ["renewal", "prospect"],
        "Targeted lifestyle credits that extend a Lifestyle Spending Account."),
    doc("ch-brochure", "ch", "Brochure Only", "CoreHealth Brochure.pdf", "BrochureOnly.png", ["prospect"],
        "The CoreHealth+ brochure."),
    doc("ch-summary", "ch", "CH+ Summary Highlights", "CoreHealth Plus Summary Highlights.pdf", "CHSummaryDocument.png", ["prospect", "learn"],
        "A summary of CoreHealth+ plan highlights."),
    doc("j-bo", "working", "The Business Owner Journey", "The Business Owner Journey.pdf", "BOthumbnail.png", ["handoff", "learn"],
        "What a business owner experiences from enrollment to first claim."),
    doc("j-emp", "working", "The Employee Journey", "The Employee Journey.pdf", "EEthumbnail.png", ["handoff", "learn"],
        "What employees experience from welcome email to reimbursement."),
    doc("j-pa", "working", "The PA Journey", "The PA Journey.pdf", "PAthumbnail.png", ["handoff", "learn"],
        "What Plan Administrators experience from setup to day-to-day management."),
    doc("pa-hsa", "working", "What PAs can expect with NHC on an HSA Plan", "What PAs can expect with NHC on an HSA Plan.pdf", "PAExpectations.png", ["handoff"],
        "What Plan Administrators can expect once an HSA plan is live."),
    doc("pa-hb", "pa", "Plan Admin Handbook", "PlanAdministrator(PA)-Handbook.pdf", "PAHandbook.png", ["handoff"],
        "A reference guide for Plan Administrators managing their plan."),
    doc("emp-hsa", "emp", "HSA Employee Handbook", "Employee HSA User Handbook.pdf", "HealthSpendingAccount.png", ["handoff"],
        "How employees use their Health Spending Account."),
    doc("emp-lsa", "emp", "LSA Employee Handbook", "Employee LSA User Handbook.pdf", "LifestyleSpendingAccount.png", ["handoff"],
        "How employees use their Lifestyle Spending Account."),
];

const storyFile = (story, region) => ({
    story,
    region,
    href: `/files/meet-gary/${region.toLowerCase()}-${story}.pdf`,
    thumbnail: `/thumbnails/meet-gary/${region.toLowerCase()}-${story}.jpg`,
});

export const MEET_GARY = {
    regions: ["Western", "Ontario", "Atlantic"],
    industries: [
        { id: "trades", label: "Trades & industrial" },
        { id: "auto", label: "Auto & transport" },
        { id: "retail", label: "Retail & food" },
        { id: "pro", label: "Health & professional" },
        { id: "general", label: "General" },
    ],
    stories: [
        { id: "gary", name: "Gary", industry: "Small business owner", group: "general" },
        { id: "mike", name: "Mike", industry: "Small business owner", group: "general" },
        { id: "kyle", name: "Kyle", industry: "Contracting company", group: "trades" },
        { id: "raj", name: "Raj", industry: "Industrial services", group: "trades" },
        { id: "claire", name: "Claire", industry: "Custom workshop", group: "trades" },
        { id: "marcus", name: "Marcus", industry: "Trucking company", group: "auto" },
        { id: "tony", name: "Tony", industry: "Auto parts shop", group: "auto" },
        { id: "frank", name: "Frank", industry: "Auto repair shop", group: "auto" },
        { id: "walter", name: "Walter", industry: "Neighbourhood bakery", group: "retail" },
        { id: "barb", name: "Barb", industry: "Hardware store", group: "retail" },
        { id: "jenny", name: "Jenny", industry: "Online shop", group: "retail" },
        { id: "amira", name: "Amira", industry: "Dental clinic", group: "pro" },
        { id: "laura", name: "Laura", industry: "Nutrition practice", group: "pro" },
        { id: "grace", name: "Grace", industry: "Consulting firm", group: "pro" },
    ],
    files: [
        ...["gary", "kyle", "raj", "claire", "marcus", "tony", "frank", "walter", "barb", "jenny", "amira", "laura", "grace"].flatMap((story) =>
            ["Western", "Ontario", "Atlantic"].map((region) => storyFile(story, region))
        ),
        storyFile("mike", "Atlantic"),
    ],
};
